export function setImpersonateUserStatus(status) {
  return {
    type: 'IMPERSONATE/SET_STATUS',
    payload: status
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/impersonate.js
 **/